import { Button, KIND, SIZE } from 'baseui/button'
import UserSelector from '@/containers/SubscriptionFormPageNew/Components/Tools/ChangeUser/UserSelector/UserSelector'
import { ChangeUserContainer } from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/styled-components'
import IconCarbonUser from '@/shared/icons/IconCarbonUser'
import useChangeUser from '@/containers/SubscriptionFormPageNew/Components/Tools/ChangeUser/useChangeUser'

const ChangeUser = () => {
  const {
    t,
    canShowChangeUser,
    ableChangeUser,
    users,
    userIdSelected,
    createdById,
    setUserIdSelected,
    setAbleChangeUser,
    changeUserOwner,
    importUsers,
  } = useChangeUser()

  if (canShowChangeUser === false) {
    return null
  }

  return (
    <>
      <Button
        id='change-user-open-button'
        kind={KIND.secondary}
        size={SIZE.compact}
        onClick={event => {
          event.preventDefault()
          importUsers()
        }}
        hidden={ableChangeUser}
        startEnhancer={() => <IconCarbonUser size={24} />}
      >
        {t('subscriptionForm:subscription_actions_module.change_user.activate_feature')}
      </Button>
      {ableChangeUser && (
        <ChangeUserContainer>
          <UserSelector users={users} userIdSelected={userIdSelected} setUserIdSelected={setUserIdSelected} />
          <Button
            kind={KIND.primary}
            id='change-user-update'
            size={SIZE.mini}
            overrides={{ BaseButton: { style: { marginLeft: '5px', marginRight: '5px' } } }}
            disabled={userIdSelected === createdById}
            onClick={changeUserOwner}
          >
            {t('subscriptionForm:subscription_actions_module.change_user.update')}
          </Button>
          <Button
            kind={KIND.primary}
            id='change-user-cancel-button'
            size={SIZE.mini}
            overrides={{ BaseButton: { style: { marginLeft: '5px', marginRight: '5px' } } }}
            onClick={() => setAbleChangeUser(false)}
          >
            {t('subscriptionForm:subscription_actions_module.change_user.cancel')}
          </Button>
        </ChangeUserContainer>
      )}
    </>
  )
}

export default ChangeUser
